export default "__VITE_ASSET__BuWrRwSb__"